import { capitalize } from 'vue';

import Colors from '@/Colors';
import i18n from '@/vueI18n';

export default class MapPolygonControl {
  onAdd(map) {
    this.isActive = false;
    this.mapInternal = map;
    this.containerInternal = window.document.createElement('div');
    this.containerInternal.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    const btn = window.document.createElement('button');
    btn.className = 'mapboxgl-ctrl-icon';
    btn.title = capitalize(i18n.global.t('actions.drawPolygon'));
    btn.onclick = () => {
      this.activate();
      if (this.clickHandler !== undefined) {
        this.clickHandler();
      }
    };
    btn.innerHTML =
      '<svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">\n' +
      ' <g stroke-miterlimit="10">\n' +
      '  <path transform="scale(.69444)" d="m26.888 37.508l81.439-21.476" fill="none" stroke-linecap="round" stroke-width="8"/>\n' +
      '  <path transform="scale(.69444)" d="m108.33 17.156l18.051 109.14" fill="none" stroke-linecap="round" stroke-width="8"/>\n' +
      '  <path transform="scale(.69444)" d="m126.38 127.39l-100.61-21.403" fill="none" stroke-linecap="round" stroke-width="8"/>\n' +
      '  <path transform="scale(.69444)" d="m24.311 105.4l2.9081-66.921" fill="none" stroke-linecap="round" stroke-width="8"/>\n' +
      '  <path transform="scale(.69444)" d="m110.2 109.04h27.838v26.674h-27.838z" stroke-linejoin="bevel" stroke-width="2"/>\n' +
      '  <path transform="scale(.69444)" d="m115.96 113.89h17.308v16.054h-17.308z" stroke-linejoin="bevel" stroke-width="2"/>\n' +
      '  <path transform="scale(.69444)" d="m94.41 3.8194h27.838v26.674h-27.838z" stroke-linejoin="bevel" stroke-width="2"/>\n' +
      '  <path transform="scale(.69444)" d="m100.18 8.6738h17.308v16.054h-17.308z" stroke-linejoin="bevel" stroke-width="2"/>\n' +
      '  <path transform="scale(.69444)" d="m13.298 92.059h27.838v26.674h-27.838z" stroke-linejoin="bevel" stroke-width="2"/>\n' +
      '  <path transform="scale(.69444)" d="m19.063 96.913h17.308v16.054h-17.308z" stroke-linejoin="bevel" stroke-width="2"/>\n' +
      '  <path transform="scale(.69444)" d="m12.971 25.138h27.838v26.674h-27.838z" stroke-linejoin="bevel" stroke-width="2"/>\n' +
      '  <path transform="scale(.69444)" d="m18.737 29.992h17.308v16.054h-17.308z" stroke-linejoin="bevel" stroke-width="2"/>\n' +
      ' </g>\n' +
      '</svg>\n';
    btn.firstChild.style = 'width: 20px; height: 20px;margin-top: 4px; stroke: #333;';
    this.btn = btn;
    this.containerInternal.appendChild(btn);
    return this.containerInternal;
  }

  onRemove() {
    this.containerInternal.parentNode.removeChild(this.containerInternal);
    this.mapInternal = undefined;
  }

  activate() {
    this.btn.firstChild.style = `width: 20px; height: 20px;margin-top: 4px; stroke: ${Colors.actions}; fill: ${Colors.actions};`;
  }

  deactivate() {
    this.btn.firstChild.style = 'width: 20px; height: 20px;margin-top: 4px; stroke: #333;';
  }
}
